import {Component, Prop, Vue} from "vue-property-decorator";
import {className} from "~/lib/helpers/string";

@Component
export class Tabs extends Vue {
  render() {
    return <ul class="tabs">{this.$slots.default}</ul>
  }
}

@Component
export class Tab extends Vue {

  @Prop({type: Boolean, default: false}) isActive: boolean

  render() {
    return (
      <li onClick={e => this.$emit("click", e)} class={className("tab", {isActive: this.isActive})}>
        {this.$slots.default}
      </li>
    );
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-5fc2982c/tabs.tsx" });